export const fromPxToInit = '(min-width: 768px)';
export const fromPxMToInit = '(min-width: 1009px)';
export const TABLET_PX = 1008;
export const MOBILE_PX = 768;
export const isDesktop = window.matchMedia(fromPxMToInit).matches;
export const isTablet = window.matchMedia(fromPxToInit).matches;

